import './music.css'
import { Layout, Row, Col,ConfigProvider,Card } from 'antd';
import React, { Component, Fragment } from "react";
import cabezal from './static/img/Cabezal_Music.jpg'
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import { Button } from 'antd';

class Home extends Component {
  constructor(props){
    super(props)
    this.state={
      phone: '',
      sended: false,
      showRegistrate: false,
      genres:[],
      fileList: [],
      authors:[],
    }
    // const promise = axios.get('https://back.premiocasa.cult.cu/api/musica/genero/')
    // const dataPromise = promise.then((response)=> response.data)
    // console.log(dataPromise)
  }

  

  render() {
    
   
      const { Header, Footer, Content } = Layout;
      
    return (

      <div className="page-container">
      <div className = "content-wrap">
        <ConfigProvider locale={es_ES}>
<Layout style={{backgroundColor:'white'}}>
          <Row>
            <Col><NavLink to="/musicologia"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
          </Row>
         
          <Row justify="center" align="middle" >
            <Col xs={{span:24}} sm={{span:18}}>
            <Card title='Premio de Musicología Casa de las Américas' bordered={false}>
            <p style={{textAlign:'justify', textJustify:'inter-word'}}>Desde 1979, el Premio de Musicología Casa de las Américas constituye una valiosa plataforma de gestión para estimular la investigación, el conocimiento y la difusión de la cultura musical de la América Latina y el Caribe. Con casi cuarta cinco años de labor sostenida, el certamen ha sido posible gracias al apoyo y la colaboración que ha recibido por parte de los músicos y musicólogos de la región, cuya presencia ha tramado la historia y tradición del Premio y su Coloquio Internacional.</p>
<p style={{textAlign:'justify', textJustify:'inter-word'}}>Debido al interés que mantiene su convocatoria, al prestigio de sus jurados y al alto grado de impacto internacional que signa a los galardonados, el Premio de Musicología ha llegado a convertirse en uno de los más altos reconocimientos que se otorga a la investigación musicológica en este continente.</p>
   <p style={{textAlign:'justify', textJustify:'inter-word'}}>Veintiseis títulos premiados  conforman la Colección Premio de Musicología Casa de las Américas, a lo que se suma el archivo de textos inéditos concursantes. Este conjunto documental constituye un valioso acervo de conocimiento sobre procesos de la música latinoamericana y caribeña y sus contextos, al tiempo que registra la historia de la disciplina en nuestra región.</p>
   <p style={{textAlign:'justify', textJustify:'inter-word'}}>En esta decimonovena edición del Premio de Musicología Casa de las Américas las obras en concurso serán recibidas a través del portal digital<a  target="_blank" href="https://premiocasa.cu/musicologia">https://premiocasa.cu/musicologia</a>que estará disponible desde el 1ro de noviembre de 2023 hasta el 29 de febrero de 2024.</p>
      <p style={{textAlign:'justify', textJustify:'inter-word'}}>
      Según las bases oficiales del concurso, podrán participar autores latinoamericanos y caribeños, naturales o naturalizados, con libros que contribuyan a una comprensión más integral de la música y la cultura de la América Latina y del Caribe, a partir de los diversos conceptos y procedimientos de las ciencias sociales contemporáneas. Concursarán textos inéditos sobre: historiografía musical; interpretación y explicación crítica de la creación musical; música tradicional y folclórica; teoría y práctica de la enseñanza de la música; marcos teóricos globales de la musicología; y otros problemas relacionados con la estética, la sociología y la antropología de la música, entre otros.
      </p>
      <p style={{textAlign:'justify', textJustify:'inter-word'}}>
      El jurado estará integrado por personalidades de la musicología hispanoamericana y su dictamen se dará a conocer el viernes 15  de marzo de 2024.
      </p>
    <Row justify="center" align="middle" gutter={24}>
            <Col xs={{span:19}} sm={{span:24}} >
                <Button style={{backgroundColor:'#ed7e8e', color:'white', width:'250px'}}><NavLink to="/musicologia/registro">Registro</NavLink></Button>
            </Col>
          </Row>
    </Card>
      
    </Col>
          </Row>
          <Content>
          </Content>
          

          </Layout>
        </ConfigProvider>

    </div>
    <Footer style={{backgroundColor:'#ed7e8e', position:'relative',bottom:'0px',left:'0px',right:'0px'}}>
        <Row justify="center" align="middle" style={{ width:'100%', backgroundColor:'#ed7e8e',  marginBottom:'0px', bottom:'0px'}}>
          <Col xl={6} xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}>  <NavLink to="/musicologia/bases" style={{color:'white'}}>Bases del concurso</NavLink></div></Col>
          <Col  xl={4}xs={24} sm={{span:6}}><div style={{textAlign: 'center'}}><a style={{color:'white'}} href = "mailto:  dirmusica@casa.cult.cu"> dirmusica@casa.cult.cu</a></div></Col>
          <Col  xl={{span:4, offset:2}} sm={{span:6}} xs={{span:24}} ><div style={{textAlign: 'center'}}><a style={{color:'white', textAlign: 'center'}} target="_blank" href="http://www.casadelasamericas.org/"> Sitio Oficial Casa de las Américas</a> </div></Col>
          <Col xl={4}xs={24}sm={{span:6}} ><div style={{textAlign: 'center'}}><a style={{color:'white'}}target="_blank"  href="http://laventana.casa.cult.cu/"> La Ventana</a></div></Col>
          <Col  xl={4} xs={24} sm={{span:24}}><div style={{textAlign: 'center'}}><NavLink to="/musicologia/terminos" style={{color:'white'}}>Términos y condiciones de uso</NavLink></div></Col>
        </Row>
      </Footer>
</div>
    );
  }
}
export default Home;


